import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {EsportazioneArchivioPretdocComponent} from './esportazione-archivio-pretdoc';

let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

  $stateProvider
    .state('home.esportazione-archivio-pretdoc', {
      url: '/esportazione-archivio-pretdoc',
      ncyBreadcrumb: {
        label: 'Esportazione Archivio PretDoc',
        parent: 'home.admin'
      },
      data: {
        authorisationLevel: 2,
        pageTitle: 'Esportazione Archivio PretDoc'
      },
      'views': {
        'homeContent': {
          template: '<esportazione-archivio-pretdoc flex="100"></esportazione-archivio-pretdoc>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const EsportazioneArchivioPretdocModule: string = ng
  .module('esportazione-archivio-pretdoc', [
    'ui.bootstrap',
    uiRouter,
  ])
  .component('esportazioneArchivioPretdoc', EsportazioneArchivioPretdocComponent)
  .config(stateConfig)
  .name;





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/esportazione-archivio-pretdoc/esportazione-archivio-pretdoc.module.ts